<template>
  <div class="main-auth">
      <div class="box-auth">
        <router-view/>
      </div>
    </div>
</template>

<script>
export default {
  name: "the-Auth"
}
</script>

<style lang="scss" scoped>
.main-auth {
  height: calc(100vh - 50px);
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../../assets/backgrounds/Register.png");
  background-size: cover;
  //height: 100%;
//height: calc(100vh - 60px);

  .box-auth {
    width: 380px;

    padding: 40px;
    margin: 20px 0;
    background-image: url("../../assets/backgrounds/bgnoiseeee.png");
    background-size: auto;
    background-position: center;
    border-radius: 20px;
  }
}

@media (max-width: 500px) {
  .box-auth{
    width: 300px !important;
  }
}

@media (max-width: 400px) {
  .box-auth{
    width:230px !important;
  }
}
</style>